<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CH-T"><strong>Simple Knits: Knitted Cushions &amp; Pillows</strong></h1>
<h3 class="CH-AU"><strong>12 EASY-KNIT PROJECTS FOR YOUR HOME</strong></h3>
<h3 class="CH-AU"><strong>CLAIRE CROMPTON</strong></h3>
<p class="Image-C"><img alt="" src="OEBPS/Images/logo.gif"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?463164a8